import { render, staticRenderFns } from "./factoryTable.vue?vue&type=template&id=7a72e0e8&scoped=true&"
import script from "./factoryTable.vue?vue&type=script&lang=js&"
export * from "./factoryTable.vue?vue&type=script&lang=js&"
import style0 from "./factoryTable.vue?vue&type=style&index=0&id=7a72e0e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72e0e8",
  null
  
)

export default component.exports